import React, { useEffect, useState } from "react";
import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../helpers/AsyncMessage";
import {
  Form,
  Input,
  Button,
  Select,
  Row,
  Col,
  Radio,
  DatePicker,
  Modal,
  Checkbox,
} from "antd";
import ModalSpecial from "../../../Layout/Modals/ModalSpecial";
import { useDispatch } from "react-redux";
import { useMutation, useQuery } from "react-query";
import { setGlobalModal } from "../../../../redux/Actions/orderAction";
import { ButtonDelete } from "../../../common/Buttons";
import { IconEditBold, IconCloseBold } from "../../../Layout/Icons";
import { DebounceSelect } from "../../../common";
import moment from "moment";
import { useSelector } from "react-redux";
import { IconExclamation } from "../../../Layout/Icons";

const { confirm } = Modal;

const identifierContainsLetters = (identifier) =>
  /[A-Za-z]/.test(String(identifier || ""));

const eanErrorForIdentifier = (identifier, ean) => {
  const normalizedEan = String(ean || "").trim();

  if (!normalizedEan) {
    return identifierContainsLetters(identifier) ? null : "Must be 13 digits";
  }

  return /^\d{13}$/.test(normalizedEan) ? null : "Must be 13 digits";
};

const normalizeInvoiceNumber = (invoiceNumber) => {
  const normalized = String(invoiceNumber || "").trim();
  return normalized.length > 0 ? normalized : null;
};

const MigrateProductsModal = ({ orders }) => {
  const [form] = Form.useForm();
  const globalModal = useSelector((state) => state.orders.globalModal);
  console.log(orders, "orders");
  const [orderRows, setOrderRows] = useState(
    orders.also_income_item.filter(
      (orderRow) =>
        globalModal.numbersArray.includes(orderRow.id) &&
        orderRow.deleted_at === null
    )
  );

  console.log(orderRows, "orderRows");

  const [selectedValue, setSelectedValue] = useState("ALSO");
  const [supplierId, setSupplierId] = useState("");
  const [documentId, setDocumentId] = useState("");
  const [selectMigrateType, setSelectMigrateType] = useState("existing");
  const [reviewDate, setReviewDate] = useState(moment());
  const [supplyDate, setSupplyDate] = useState(moment());
  const [documentData, setDocumentData] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const selectedDocumentData = documentData?.filter(
    (doc) => doc.id === documentId
  );
  const dispatch = useDispatch();
  const { data: commentStates } = useQuery("commentStates", () =>
    Axios.get(
      "/api/v1/comment_states/search_by_type?[q][comment_type_eq]=comment_management"
    ).then((res) => res.data)
  );

  function transformProductData(product) {
    console.log(product, "product");
    return {
      transfer_id: product.id,
      product_title: product.product_title || "Unknown Product",
      ean: (product.barcode || "").trim(),
      quantity: parseFloat(product.qty) || 0,
    };
  }

  const supplierCodeFetchOptions = async (value) => {
    try {
      let api_url = `/api/v1/suppliers?page=1&per_page=9999999&q[deleted_at_null]=1&q[rivile_supplier_code_null]=0&q[title_or_rivile_supplier_code_i_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);
      const valArr = data?.data;
      return (
        valArr.map((e) => ({
          ...e,
          value: e.id,
          label: `${e.rivile_supplier_code} - ${e.title}`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  const documentFetchOptions = async (value) => {
    try {
      let api_url = `/api/v1/also_incomes.json?page=1&per_page=50&q[status_not_in][]=in_progress&q[status_not_in][]=completed&q[status_not_in][]=require_reviewq[status_not_in][]=canceled&q[document_no_not_eq]=${orders.document_no}&q[document_no_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);
      const valArr = data?.data;
      setDocumentData(valArr);
      return (
        valArr.map((e) => ({
          ...e,
          value: e.id,
          label: `${e.document_no} (${e.supplier_code?.trim()})`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  const mutationExistingPOST = useMutation({
    mutationFn: (value) =>
      Axios.post(`/api/v1/supplying_incomes/create_po`, {
        products: orderRows.map(transformProductData),
        supplier_id: selectedDocumentData?.[0]?.supplier_id,
        client_shipment_date: moment(
          selectedDocumentData?.[0]?.shipment_date
        ).format("YYYY-MM-DD"),
        warehouse: selectedDocumentData?.[0]?.add_to,
        review_date: moment(selectedDocumentData?.[0]?.review_date).format(
          "YYYY-MM-DD"
        ),
        supply_date: moment(selectedDocumentData?.[0]?.arrival_date).format(
          "YYYY-MM-DD"
        ),
        non_consolidated: !!value.non_consolidated,
        invoice_number: normalizeInvoiceNumber(value.invoice_number),
        id: documentId || null,
      }).then((res) => res.data),
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  const mutationNewPOST = useMutation({
    mutationFn: (value) =>
      Axios.post(`/api/v1/supplying_incomes/create_po`, {
        products: orderRows.map(transformProductData),
        supplier_id: supplierId,
        client_shipment_date: moment(value.shipment_date).format("YYYY-MM-DD"),
        comment_state_id: value.comment_type,
        comment_text: value.comment,
        warehouse: selectedValue,
        review_date: moment(value.review_date).format("YYYY-MM-DD"),
        supply_date: moment(value.supply_date).format("YYYY-MM-DD"),
        non_consolidated: !!value.non_consolidated,
        invoice_number: normalizeInvoiceNumber(value.invoice_number),
        id: documentId || null,
      }).then((res) => res.data),
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  const isWeekend = (date) => {
    const day = date.day();
    return day === 0 || day === 6;
  };

  const disabledDate = (current) => {
    const today = moment().startOf("day");
    return isWeekend(current) || current.isBefore(today);
  };

  const disabledDateReview = (current) => {
    const day = moment(reviewDate).startOf("day");
    return isWeekend(current) || current.isBefore(day);
  };
  const disabledClientShipmentDate = (current) => {
    const day = moment(supplyDate).startOf("day");
    return isWeekend(current) || current.isBefore(day);
  };
  const onClose = () => {
    dispatch(setGlobalModal(false, null, null));
  };

  const groupedOrderRows = orderRows.reduce((acc, row) => {
    const sku = row.sku;
    if (!acc[sku]) {
      acc[sku] = { ...row, qty: 0 };
    }
    acc[sku].qty += parseFloat(row.qty) || 0;
    return acc;
  }, {});
  const groupedOrderRowsValues = Object.values(groupedOrderRows);
  const hasInvalidEan = groupedOrderRowsValues.some(
    (item) => !!eanErrorForIdentifier(item.sku, item.barcode)
  );

  const handleProductNameChange = (sku, value) => {
    const newOrderRows = orderRows.map((row) => {
      if (row.sku === sku) {
        return { ...row, product_title: value };
      }
      return row;
    });
    setOrderRows(newOrderRows);
  };

  const handleQuantityChange = (sku, value, id) => {
    const filteredRows = orderRows.filter(
      (row) => row.sku === sku && row.id !== id
    );
    const totalQuantity = filteredRows.reduce((sum, row) => {
      return sum + parseFloat(row.qty);
    }, 0);
    const newValue = parseFloat(value) - totalQuantity;
    const newOrderRows = orderRows.map((row) => {
      if (row.id === id) {
        return { ...row, qty: newValue };
      }
      return row;
    });
    setOrderRows(newOrderRows);
  };

  const handleEanChange = (sku, value) => {
    const sanitizedValue = String(value || "")
      .replace(/\D/g, "")
      .slice(0, 13);

    const newOrderRows = orderRows.map((row) => {
      if (row.sku === sku) {
        return { ...row, barcode: sanitizedValue };
      }
      return row;
    });
    setOrderRows(newOrderRows);
  };

  const handleDelete = (id) => {
    const index = orderRows.findIndex((row) => row.id === id);
    if (index !== -1) {
      const newOrderRows = [...orderRows];
      newOrderRows.splice(index, 1);
      setOrderRows(newOrderRows);
    }
  };

  const onFinishHandler = (values) => {
    if (hasInvalidEan) {
      antdAsyncMessageError({ text: "EAN must be exactly 13 digits" });
      return;
    }

    if (selectMigrateType === "existing" && !documentId) {
      antdAsyncMessageError({ text: "Please select a destination document" });
      return;
    }

    confirm({
      title: "Are you sure?",
      icon: <IconExclamation className="text-primary" />,
      content:
        selectMigrateType === "existing"
          ? `Once completed, this action cannot be undone. The selected products will be moved to the chosen document. Are you sure you want to proceed?`
          : `Once completed, this action cannot be undone. The selected products will be moved to a new document. Are you sure you want to proceed?`,
      onOk() {
        if (selectMigrateType === "existing") {
          mutationExistingPOST.mutate(values);
        } else {
          mutationNewPOST.mutate(values);
        }
      },
      onCancel() {
        console.log("Cancel1");
      },
    });
  };

  const [isEditing, setIsEditing] = useState(
    Array(orderRows.length).fill(false)
  );

  const renderDataTable = () => {
    return (
      <table style={{ backgroundColor: "#FBFBFB" }} className="table">
        <thead>
          <tr>
            <th>SKU</th>
            <th>EAN</th>
            <th>Title</th>
            <th>Qty</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {groupedOrderRowsValues.map((item, index) => (
            <tr key={index}>
              <td>{item.sku}</td>
              <td>
                <Input
                  style={{ width: 130 }}
                  value={item.barcode || ""}
                  maxLength={13}
                  inputMode="numeric"
                  onChange={(e) => handleEanChange(item.sku, e.target.value)}
                />
                {item.sku && eanErrorForIdentifier(item.sku, item.barcode) ? (
                  <div className="text-danger">
                    {eanErrorForIdentifier(item.sku, item.barcode)}
                  </div>
                ) : null}
              </td>
              <td>
                {isEditing[index] ? (
                  <div style={{ width: 180 }} className="d-flex flex-row">
                    <Input.TextArea
                      value={item.product_title}
                      onChange={(e) =>
                        handleProductNameChange(item.sku, e.target.value)
                      }
                    />
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        const newIsEditing = [...isEditing];
                        newIsEditing[index] = false;
                        setIsEditing(newIsEditing);
                      }}
                    >
                      <IconCloseBold />
                    </div>
                  </div>
                ) : (
                  <div style={{ width: 180 }} className="d-flex flex-row">
                    {item.product_title}
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        const newIsEditing = [...isEditing];
                        newIsEditing[index] = true;
                        setIsEditing(newIsEditing);
                      }}
                    >
                      <IconEditBold />
                    </div>
                  </div>
                )}
              </td>
              <td>
                <div className="d-flex flex-row gap-5">
                  <div>{item.qty}</div>
                </div>
              </td>
              <td>
                <ButtonDelete onDelete={() => handleDelete(item.id)} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <ModalSpecial
      style={{ width: 550 }}
      text={
        <span className="font-bold text-xl text-black">Migrate products</span>
      }
      onClose={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          onFinishHandler(values);
        }}
        autoComplete="off"
      >
        <Form.Item
          style={{ marginBottom: 0 }}
          label="Migration type"
          name="migrate_type"
        >
          <Row gutter={16}>
            <Col span={12}>
              <div
                className="card-type ant-input cursor-pointer"
                style={{
                  height: 32,
                  borderColor:
                    selectMigrateType === "existing" ? "#03B0F7" : "",
                  backgroundColor:
                    selectMigrateType === "existing" ? "#EDF9FE" : "",
                }}
                onClick={() => setSelectMigrateType("existing")}
              >
                <Radio
                  className={
                    selectMigrateType === "existing" ? "selected-radio" : ""
                  }
                  style={{
                    color: selectMigrateType === "existing" ? "#03B0F7" : "",
                  }}
                  checked={selectMigrateType === "existing"}
                  value="existing"
                >
                  To existing PO
                </Radio>
              </div>
            </Col>
            <Col span={12}>
              <div
                className="card-type ant-input cursor-pointer"
                style={{
                  height: 32,
                  borderColor: selectMigrateType === "new" ? "#03B0F7" : "",
                  backgroundColor: selectMigrateType === "new" ? "#EDF9FE" : "",
                }}
                onClick={() => setSelectMigrateType("new")}
              >
                <Radio
                  className={
                    selectMigrateType === "new" ? "selected-radio" : ""
                  }
                  style={{
                    color: selectMigrateType === "new" ? "#03B0F7" : "",
                  }}
                  checked={selectMigrateType === "new"}
                  value="new"
                >
                  Create new PO
                </Radio>
              </div>
            </Col>
          </Row>
        </Form.Item>
        {selectMigrateType === "existing" ? (
          <>
            <Form.Item
              style={{ marginBottom: 0 }}
              label="Document receiving products"
              name="document"
            >
              <DebounceSelect
                labelInValue={false}
                required={true}
                showSearch={true}
                value={documentId}
                placeholder={"Type to search"}
                fetchOptions={documentFetchOptions}
                onChange={(value) => {
                  console.log(value, "value");
                  setDocumentId(value);
                }}
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
          </>
        ) : (
          <>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                style={{ marginBottom: 0 }}
                label="Supplier invoice number"
                name="invoice_number"
              >
                <Input maxLength={128} placeholder="Enter invoice number" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                style={{ marginBottom: 0, paddingTop: 30 }}
                name="non_consolidated"
                valuePropName="checked"
                initialValue={false}
              >
                <Checkbox>Do not combine</Checkbox>
              </Form.Item>
            </Col>
          </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  style={{ marginBottom: 0 }}
                  label="Supplier code"
                  name="supplier_code"
                  rules={[
                    { required: true, message: "Supplier code is required" },
                  ]}
                >
                  <DebounceSelect
                    labelInValue={false}
                    required={true}
                    showSearch={true}
                    value={supplierId}
                    placeholder={"Type to search"}
                    fetchOptions={supplierCodeFetchOptions}
                    onChange={(value) => {
                      console.log(value, "value");
                      setSupplierId(value);
                    }}
                    style={{
                      width: "100%",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  style={{ marginBottom: 0 }}
                  label="Arriving to location"
                  name="supply_date"
                  rules={[
                    { required: true, message: "Supply date is required" },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledDateReview}
                    style={{ width: "100%" }}
                    placeholder="Select"
                    onChange={(value) => setSupplyDate(value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  style={{ marginBottom: 0 }}
                  label="Purchase order review date"
                  name="review_date"
                  rules={[
                    { required: true, message: "Review date is required" },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledDate}
                    style={{ width: "100% " }}
                    placeholder="Select"
                    onChange={(value) => setReviewDate(value)}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  style={{ marginBottom: 0 }}
                  label="Client shipment date"
                  name="shipment_date"
                >
                  <DatePicker
                    disabledDate={disabledClientShipmentDate}
                    style={{ width: "100% " }}
                    placeholder="Select"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              style={{ marginBottom: 0 }}
              label="Arrival warehouse"
              name="arrival_warehouse"
            >
              <Row gutter={16}>
                <Col span={6}>
                  <div
                    className="card-type ant-input cursor-pointer"
                    style={{
                      height: 32,
                      borderColor: selectedValue === "ALSO" ? "#03B0F7" : "",
                      backgroundColor:
                        selectedValue === "ALSO" ? "#EDF9FE" : "",
                    }}
                    onClick={() => setSelectedValue("ALSO")}
                  >
                    <Radio
                      className={
                        selectedValue === "ALSO" ? "selected-radio" : ""
                      }
                      style={{
                        color: selectedValue === "ALSO" ? "#03B0F7" : "",
                      }}
                      checked={selectedValue === "ALSO"}
                      value="ALSO"
                    >
                      ALSO
                    </Radio>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    className="card-type ant-input cursor-pointer"
                    style={{
                      height: 32,
                      borderColor: selectedValue === "Office" ? "#03B0F7" : "",
                      backgroundColor:
                        selectedValue === "Office" ? "#EDF9FE" : "",
                    }}
                    onClick={() => setSelectedValue("Office")}
                  >
                    <Radio
                      className={
                        selectedValue === "Office" ? "selected-radio" : ""
                      }
                      style={{
                        color: selectedValue === "Office" ? "#03B0F7" : "",
                      }}
                      checked={selectedValue === "Office"}
                      value="Office"
                    >
                      Office
                    </Radio>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    className="card-type ant-input cursor-pointer"
                    style={{
                      height: 32,
                      borderColor: selectedValue === "Adrem" ? "#03B0F7" : "",
                      backgroundColor:
                        selectedValue === "Adrem" ? "#EDF9FE" : "",
                    }}
                    onClick={() => setSelectedValue("Adrem")}
                  >
                    <Radio
                      className={
                        selectedValue === "Adrem" ? "selected-radio" : ""
                      }
                      style={{
                        color: selectedValue === "Adrem" ? "#03B0F7" : "",
                      }}
                      checked={selectedValue === "Adrem"}
                      value="Adrem"
                    >
                      Adrem
                    </Radio>
                  </div>
                </Col>
                <Col span={6}>
                  <div
                    className="card-type ant-input cursor-pointer"
                    style={{
                      height: 32,
                      borderColor: selectedValue === "VLANTANA" ? "#03B0F7" : "",
                      backgroundColor: selectedValue === "VLANTANA" ? "#EDF9FE" : "",
                    }}
                    onClick={() => setSelectedValue("VLANTANA")}
                  >
                    <Radio
                      className={selectedValue === "VLANTANA" ? "selected-radio" : ""}
                      style={{
                        color: selectedValue === "VLANTANA" ? "#03B0F7" : "",
                      }}
                      checked={selectedValue === "VLANTANA"}
                      value="VLANTANA"
                    >
                      VLANTANA
                    </Radio>
                  </div>
                </Col>
              </Row>
            </Form.Item>
          </>
        )}
        <hr />
        {renderDataTable()}

        <Form.Item>
          <Button
            disabled={groupedOrderRowsValues.length === 0 || hasInvalidEan}
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={
              mutationNewPOST.isLoading || mutationExistingPOST.isLoading
            }
          >
            Save
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

export default MigrateProductsModal;
